<div *ngIf="report">

  <div [style]="styles.header.page">
    <div [style]="styles.header.text">
      <b>{{ secondaryStrength }}</b>
    </div>
    <div [style]="styles.header.line"></div>
  </div>

  <div [style]="styles.container_padding">

    <h2 [style]="styles.general_h2">
      <b>
        {{
        isFacilitator
        ? 'Your Secondary Facilitator Style'
        : 'Secondary Preferred Coaching Style from You – ' + (report.name || '...')
        }}
      </b>
    </h2>

    <p [style]="styles.paragraph">
      {{
      isFacilitator
      ? 'Your secondary facilitator style is the'
      : 'Their secondary preferred coaching style from you is the'
      }}
      <span [style]="styles.highlight">{{ report.secondaryCoachingStyle || '...' }}</span>.
    </p>

    <p [style]="styles.paragraph" [innerHTML]="html"></p>

  </div>

</div>